import { capitalize } from 'lodash-es';

import * as Models from 'contracts/models';

export function formatLicenseName(license: Models.UserInfo.License) {
    return `${capitalize(license.licenseType)} license`;
}
